import moment from 'moment'
import deLocaleData from 'react-intl/locale-data/de'
import {addLocaleData} from 'react-intl'
import Modal from 'react-modal'
import underscore from 'underscore'
import {Quill} from 'react-quill'
import Immutable, {Record} from 'immutable'
import FileSaver from 'file-saver'
import eraserIcon from '../_static/images/eraser.svg'
import queryString from 'query-string'


/*
* disable React Intl warnings
* https://github.com/yahoo/react-intl/issues/465
* */
const consoleError = console.error.bind(console);
// eslint-disable-next-line
console.error = (message, ...args) => {
    if (typeof message === 'string' && (
            message.startsWith('[React Intl] Missing message:') ||
            message.startsWith('[React Intl] Cannot format message:')
        )
    ) {
        return;
    }
    consoleError(message, ...args);
};


/*
* TODO dev only
* */
window.moment = moment
// window.EditorState = EditorState
// window.convertToRaw = convertToRaw
// window.convertFromRaw = convertFromRaw
window.Immutable = Immutable
window.Record = Record
window.underscore = underscore
window.FileSaver = FileSaver
window.queryString = queryString

// window.draftToHtml = draftToHtml
// window.htmlToDraft = htmlToDraft
// window._convertToHTML = convertToHTML
// window._convertFromHTML = convertFromHTML
// window._createVideoPlugin = createVideoPlugin
// window._createImagePlugin = createImagePlugin

addLocaleData(deLocaleData) // TODO think of locale set after getting languages in Init

Modal.setAppElement('#root')



// <script src="https://cloud.tinymce.com/stable/tinymce.min.js?apiKey=dnmlt44eonw7v2yhx9o5q74y1s8y9inyqnjnw7uvjpavc6si"></script>


/*
* https://github.com/zenoamaro/react-quill/issues/188#issuecomment-294092442
* */
const configReactQuillToolbarIcons = () => {
    let icons = Quill.import('ui/icons');
    icons['clean'] = `<img src="${eraserIcon}" width="18" height="18" alt="" />`
}

configReactQuillToolbarIcons()


export const SMS_DONATE_ID = 425626
export const SMS_DONATE_LANGUAGE = 'english'


export const PAYPAL_DONATE_LINK = "https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=GWFRWTBQQR7JN"
export const PAYPAL_DONATE_POPOVER_INIT_TIMER = 15000


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/settings/settings.js